import Container from 'typedi';
import DriverRepository from '../repositories/DriverRepository';
class DriverService {
  driverRepository;
  constructor() {
    this.driverRepository = Container.get(DriverRepository);
  }
  getDrivers = async (includeOnlyUsers) => await this.driverRepository.getDrivers(includeOnlyUsers);
}

Container.set({ id: DriverService, type: DriverService });

export default DriverService;
